import { AppManager } from 'core/appManager';
import { clientStore } from 'apps/client/app';

import {
  ContextConversationQuery,
  ConversationQueryWithParticipants,
} from './gql';

export default class BidirectionalQueryManager extends AppManager {
  constructor(options) {
    super();
    this.minOffset = options.startOffset || 0;
    // this.maxOffset = options.startOffset || 0;
    this.contextId = options.contextId;
    this.resourceId = options.resourceId;
    this.referenceId = options.referenceId || undefined;
    this.pageSize = options.pageSize || 10;
    this.onPrevResultCb = options.onPrevResultCb;
    this.onNextResultCb = options.onNextResultCb;
    this.finished = false;
    this.running = false;
  }

  doQueryWithOffsetFirst(offset, first, cb) {
    if (offset === 0 && first === 0) {
      cb();
      return;
    }
    if (!this.running && !this.finished) {
      this.running = true;

      let Query = ContextConversationQuery;

      if (clientStore.hasRole('INTERMEDIATOR')) {
        Query = ConversationQueryWithParticipants;
      }

      const q = new Query(this, {
        onSysErr: () => {
          this.running = false;
          // eslint-disable-next-line no-console
          console.log('Error doing bidirectional query');
        },
        variables: {
          contextId: this.contextId,
          resourceId: this.resourceId,
          referenceId: this.referenceId,
          first,
          offset,
        },
      });
      q.process(
        x => x,
        (result, query) => {
          this.running = false;
          if (!result) return;
          cb(query.variables.offset, query.variables.first, result);
        },
      );
      q.query();
    }
  }

  queryPreviousPage() {
    // We need to query the previous page. Todo so, we use the minOffset.
    // Initially, minOffset will be messages.total - messages.nodes.length

    // Don't do anything if we finished the connection
    if (this.finished === true) {
      this.onPrevResultCb(undefined);
      return;
    }
    if (this.running) {
      return;
    }

    // If there is still data to be queried, we need to calculate the index
    // and the offset. There are two scenarios:
    //  A - There are less than *pageSize* messages
    //  B - We still can query *pageSize*

    let first = -1;
    let offset = -1;

    if (this.minOffset < this.pageSize) {
      // A
      first = this.minOffset; // Query the first N messages
      offset = 0; // Offset will be always 0
    } else {
      // B
      first = this.pageSize; // Query the first *pageSize* messages
      offset = this.minOffset - this.pageSize; // after this offset
    }

    if (this.finished === false) {
      this.doQueryWithOffsetFirst(offset, first, (off, fir, result) => {
        if (off !== undefined && fir !== undefined && result !== undefined) {
          if (off === 0) {
            this.finished = true;
          }

          // Always update the internal parameters
          this.minOffset -= result.messages.nodes.length;
          this.minOffset = Math.max(this.minOffset, 0);

          if (result.messages.nodes.length >= 0) {
            this.onPrevResultCb(result);
          }
        } else {
          this.onPrevResultCb(undefined);
        }
      });
    } else {
      this.onPrevResultCb(undefined);
    }
  }
  /*
  queryNextPage() {
    if (Math.floor(this.totalElements / this.pageSize) >= this.maxMessagePage) {
      this.onNextResultCb(undefined);
      return;
    }

    this.doQueryWithOffset(this.maxMessagePage * this.pageSize, result => {
      this.maxMessagePage += 1;
      this.onNextResultCb(result);
    });
  } */
}
